// eslint-disable-next-line custom/no-restricted-imports
import { splitEvery, values } from 'ramda';
import type { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { isHttpError, fromAxiosError } from '@peloton/api/ClientError';
import type { Client } from '@peloton/api/utils';
import { sendStatPackets } from '../api';
import type { Packet } from '../models';

export const API_PACKET_LENGTH_MAX = 200;

export const batchSendPackets = function* (
  client: Client,
  workoutId: string,
  packets: Packet[],
): SagaIterator {
  const uniquePackets = packets.reduce((acc, cur) => {
    // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'
    acc[cur.secondsOffsetFromStart] = cur;
    return acc;
  }, {});

  const batchedPackets = splitEvery(API_PACKET_LENGTH_MAX, values(uniquePackets));
  let unprocessedPackets: Packet[] = [];
  try {
    for (const batch of batchedPackets) {
      unprocessedPackets = [
        ...unprocessedPackets,
        ...(yield call(sendPackets, client, workoutId, batch)),
      ];
    }
  } catch (_) {
    // Early-exit on HTTP status code failures
  }

  return unprocessedPackets;
};

const sendPackets = function* (client: Client, workoutId: string, packets: Packet[]) {
  try {
    yield call(sendStatPackets, client, workoutId, packets);
  } catch (e) {
    if (isHttpError(e) || isHttpError(fromAxiosError(e))) {
      throw e;
    } else {
      return packets;
    }
  }

  return [];
};
